import {
  useGetMasterDistrict,
  useGetMasterProvince,
  useGetMasterTransportByIdMutation,
  useGetTransportType,
  useMasterBoxSize,
  useMasterTransport,
} from "hooks/useMasterData";
import {
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  Space,
  TimePicker,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  DeliveryPointData,
  GetOrderDetailData,
  MasterBoxData,
  MasterTransport,
  Transportbuslist,
} from "services/interface";
import { useConfirmOrderTransport } from "hooks/useOrders";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ModalTransport from "./ModalTransport";
import { useAppSelector } from "store";
import {
  useCreateDeliveryPoint,
  useCreateParking,
  useDeliveryPoint,
  useGetParkingList,
} from "hooks/useShipping";
import DescriptionForm from "components/ManageTransportaition/ModalCreateDeliveryPoint/DescriptionForm";
import styled from "@emotion/styled";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

dayjs.extend(customParseFormat);

interface TransportSeleectProps {
  formTransport: FormInstance<any>;
  item: GetOrderDetailData;
  refetchData: () => void;
  refectShipped?: () => void;
  statusPage: string;
  onClose: () => void;
  memo: string;
}

interface Box {
  box_id?: number;
  qty?: number;
}

const { Option } = Select;

const TransportSeleect = ({
  formTransport,
  item,
  refetchData,
  refectShipped,
  statusPage,
  onClose,
  memo,
}: TransportSeleectProps) => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const [masterTransport, setMasterTransport] = useState<MasterTransport[]>([]);
  const [selectTransport, setSelectTransport] = useState<MasterTransport>();

  const [provinceIdAddress, setProvinceIdAddress] = useState<number>(0);
  const [districtIdAddress, setDistrictIdAddress] = useState<number>(0);

  const [provinceIdstart, setProvinceIdstart] = useState<number>(0);
  const [provinceIdend, setProvinceIdend] = useState<number>(0);

  const [formConfigs] = Form.useForm();
  const [formModal] = Form.useForm();

  const [showParking, setShowParking] = useState<boolean>(false);

  const { mutate: CreateParking } = useCreateDeliveryPoint();
  const { mutate: confirmTransport } = useConfirmOrderTransport();
  const { mutate: getDeliveryPoint } = useDeliveryPoint();
  const { data: masterTransportType } = useGetTransportType();

  const [masterBoxSizeRemain, setMasterBoxSizeRemain] = useState<
    MasterBoxData[]
  >([]);

  const [boxes, setBoxes] = useState<Box[]>([]);

  const { data: masterBoxSize } = useMasterBoxSize();

  const [search, setSearch] = useState<string>("");

  const [transportIdSelect, setTransportIdSelect] = useState<string>("");

 // const [transportType, setTransportType] = useState<string>("");

  const [deliveryPointList, setDeliveryPointList] = useState<
    DeliveryPointData[]
  >([]);

  const [deliveryPointSelect, setDeliveryPointSelect] =
    useState<DeliveryPointData>();

  const [deleveryPointId, setDeleveryPointId] = useState<string>(
    item.parking_id ?? ""
  );

  const [times, setTimes] = useState<string[]>([]);

  const { data: masterProviceData } = useGetMasterProvince();

  const { data: masterDistrictDataStart } =
    useGetMasterDistrict(provinceIdstart);

  const { data: masterDistrictDataAddress } =
    useGetMasterDistrict(provinceIdAddress);

  const { data: masterDistrictDataEnd } = useGetMasterDistrict(provinceIdend);

  const { data, isLoading, refetch } = useMasterTransport({
    search: search,
    parking_id: deleveryPointId,
  });

  const { mutate } = useGetMasterTransportByIdMutation();

  useEffect(() => {
    if (data) {
      setMasterTransport(data.data.master_data);
    }
  }, [data]);

  useEffect(() => {
    formTransport.resetFields();
  }, [formTransport]);

  const [childrenParking, setChildrenParking] = useState<React.ReactNode[]>([]);

  //const { mutate: ParkingById, } = useGetParkingList();

  const onCloseModal = () => {
    formModal.resetFields();
    setShowParking(false);
  };

  // const getParkingList = (typeId: string) => {
  //   ParkingById(typeId, {
  //     onSuccess: (res) => {
  //       if (res.status === "success") {
  //         const newChildrenTransport = res.data.map((item: any) => (
  //           <Option key={item.id} value={item.id}>
  //             {item.delivery_point}
  //           </Option>
  //         ));
  //         setChildrenParking(newChildrenTransport);
  //       } else {
  //         // message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
  //       }
  //     },
  //     onError: (error) => {
  //       // message.error(`ลบไม่สำเร็จ: ${error.message}`);
  //     },
  //   });
  // };

  const childrenTransport: React.ReactNode[] = [];
  masterTransport?.map((item) => {
    return childrenTransport.push(
      <Option key={item.id} value={item.id}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>{`${item.name} `}</div>

          {/* <div>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                
              }}
            >
              ลบ
            </Button>
          </div> */}
        </div>
      </Option>
    );
  });

  const childrenTransportType: React.ReactNode[] = [];
  masterTransportType?.map((item) => {
    return childrenTransportType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenProviceStart: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceStart.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceAddress: React.ReactNode[] = [];
  masterDistrictDataAddress?.map((item) => {
    return childrenProviceAddress.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceEnd: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceEnd.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });


  const filterOption = (input: string, option: any) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  useEffect(() => {
    if (selectTransport) {
      setProvinceIdstart(selectTransport.province_start_id);
      setProvinceIdend(selectTransport.province_end_id);

      formTransport.setFieldsValue({
        transport_name: selectTransport.name,
        province_start_id: selectTransport.province_start_id,
        district_start_id: selectTransport.district_start_id,
        province_end_id: selectTransport.province_end_id,
        district_end_id: selectTransport.district_end_id,
        //station_start: selectTransport.station_start,
        // station_end: selectTransport.station_end,
        type: selectTransport.type,
        // license_plate: selectTransport.license_plate,
        // car_no: selectTransport.car_no,
        // timeStart: selectTransport.time_start
        //   ? dayjs(selectTransport.time_start, "HH:mm")
        //   : null,
        // timeEnd: selectTransport.time_end
        //   ? dayjs(selectTransport.time_end, "HH:mm")
        //   : null,
      });
    }
  }, [formTransport, selectTransport]);

  useEffect(() => {
    if (item.history_transport?.transport_name) {
      setProvinceIdstart(item.history_transport?.province_start_id);
      setProvinceIdend(item.history_transport?.province_end_id);

      formTransport.setFieldsValue({
        // transport_id: item.history_transport?.config_id;
        // transport_id: item.history_transport?.master_transport_id,
        // transport_name: item.history_transport?.transport_name,
        // province_start_id: item.history_transport?.province_start_id,
        // district_start_id: item.history_transport?.district_start_id,
        // province_end_id: item.history_transport?.province_end_id,
        // district_end_id: item.history_transport?.district_end_id,
        // remark: item.address_remark ?? "",
        // station_start: item.history_transport?.station_start,
        // station_end: item.history_transport?.station_end,
        // type: item.history_transport?.history_transport_type,
        // license_plate: item.history_transport?.license_plate,
        // car_no: item.history_transport?.car_no,
        // timeStart: item.history_transport.start_time ? dayjs(item.history_transport.start_time, "HH:mm") : null,
        // timeEnd: item.history_transport.end_time ? dayjs(item.history_transport.end_time, "HH:mm") : null,
      });
      // getParkingList(item.history_transport.master_transport_id);
    }

    getDeliveryPoint(
      {
        district_id: item.district_id ?? "",
        province_id: item.province_id,
        //factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            // message.success("สร้างสำเร็จ");
            setDeliveryPointList(res.data.data);
            console.log(res);
            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option key={item.id} value={item.id}>
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );


    formTransport.setFieldsValue({
      district_address_id: item.district_id,
      province_address_id: item.province_id,
      parking_id: item.parking_id,
      remark: item.address_remark ?? "",
    });
    setProvinceIdAddress(item.province_id);
    setDistrictIdAddress(item.district_id);
  }, [formTransport, item]);


  useEffect(() => {
    if (item.parking_id) {
      const parking = deliveryPointList.find((i) => i.id === item.parking_id);
      if (parking) {
        formTransport.setFieldsValue({
          parking_id: parking.id,
        });
      }else{
        formTransport.setFieldsValue({
          parking_id: undefined,
        });
      }
    }
  }, [item, deliveryPointList, formTransport]);

  useEffect(() => {
    getDeliveryPoint(
      {
        district_id: districtIdAddress,
        province_id: provinceIdAddress,
        //factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            //message.success("สร้างสำเร็จ");

            setDeliveryPointList(res.data.data);
            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option key={item.id} value={item.id}>
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  }, [districtIdAddress, getDeliveryPoint, provinceIdAddress, showParking]);

  const handelFinish = (value: any) => {
    const retail_order_item_id: string[] = [];
    item?.items.map((i) => {
      return i.keys.items.map((j) => {
        return retail_order_item_id.push(j);
      });
    });

    const transport_bus_list: Transportbuslist[] = [];
    retail_order_item_id.map((i, index) => {
      return transport_bus_list.push({
        master_transport_id: selectTransport?.id || "",
        order_id: item?.order_id,
        order_item_id: i,
        product_id: item?.items[index].product_id,
        station_start: value.station_start || "",
        province_start_id: value.province_start_id || null,
        district_start_id: value.district_start_id || null,
        station_end: value.station_end || "",
        province_end_id: value?.province_end_id || null,
        district_end_id: value?.district_end_id || null,
        time_start: dayjs(value?.timeStart).format("HH:mm") || null,
        time_end: value?.timeEnd,
        // service_price: item?.transport_price || 0,
        transport_type: selectTransport?.type || "",
        car_no: value?.car_no || "",
        license_plate: value?.license_plate || "",
        name: value?.transport_name || "",
        // description: value?.remark || "",
        parking_id: value?.parking_id || "",
        remark: value?.remark || "",
        order_box: value?.order_box || "",
        transport_box: value?.transport_box || "",
        remark_box: value?.remark_box || "",
        box_list: value?.boxes || [],
        transport_name: value?.transport_name || "",
      });
    });

    console.log("transport_bus_list::::::>", value);

    confirmTransport(
      {
        factory_id: factoryId || "",
        remark: "",
        transport_bus_list: transport_bus_list,
        transport_postal_list: [],
        memo: memo,
      },
      {
        onSuccess: async (data) => {
          if (data.status === "success") {
            message.success("ยืนยันการส่งสำเร็จ");
            refetchData();
            refectShipped && refectShipped();
            onClose();
            formTransport.resetFields();
            formTransport.setFieldsValue({ boxes: [{}] });
            setBoxes(formTransport.getFieldValue("boxes"));
          } else {
            message.error(`ยืนยันไม่สำเร็จ: ${data.error_message}`);
          }
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  const onFinishModal = (values: any) => {
    CreateParking(
      {
        factory_id: factoryId || "",
        name: values.name,
        district_id: districtIdAddress,
        province_id: provinceIdAddress,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("สร้างสำเร็จ");
            // getParkingList(selectTransport?.id || "");
            onCloseModal();
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  useEffect(() => {
    const fields = formTransport.getFieldValue("boxes");
    if (!fields || fields.length === 0) {
      formTransport.setFieldsValue({ boxes: [{}] });
    }
    setBoxes(formTransport.getFieldValue("boxes") || []);
  }, [formTransport]);

  useEffect(() => {
    console.log("boxes:", boxes);
    if (masterBoxSize && masterBoxSize.data) {
      console.log("masterBoxSize:", masterBoxSize);
      const boxSizeRemain = masterBoxSize.data.filter((item: any) => {
        return (
          boxes.filter(
            (box) => box.box_id !== undefined && box.box_id === item.id
          ).length === 0
        );
      });
      console.log("boxSizeRemain:", boxSizeRemain);
      setMasterBoxSizeRemain(boxSizeRemain);
    }
  }, [masterBoxSize, boxes]);

  useEffect(() => {
    console.log("deliveryPointSelect:", deliveryPointSelect);
    if (deliveryPointSelect) {
      //convert times to array "[08:00,09:00]"
      // if (deliveryPointSelect.times) {
      //   const time = deliveryPointSelect.times
      //     ?.replace("[", "")
      //     .replace("]", "")
      //     .split(",");
      //   console.log("time:===>", time);
      //   setTimes(time);
      // } else {
      //   setTimes([]);
      // }
    }
  }, [deliveryPointSelect]);

  useEffect(() => {
    if (transportIdSelect) {
      mutate(transportIdSelect, {
        onSuccess: (res) => {
          if (res.status === "success") {
            let parking = res.data.parking_list.find((item) => {
              return item.parking_id.includes(deleveryPointId);
            });

            console.log("parking:", parking);

            if (parking?.times) {
              const time = parking?.times
                ?.replace("[", "")
                .replace("]", "")
                .split(",");

              console.log("time:===>", time);

              setTimes(time);
            }
          } else {
          }
        },
      });
    }
  }, [transportIdSelect, deleveryPointId]);

  useEffect(() => {
   // formTransport.resetFields();
    formTransport.setFieldsValue({ boxes: [{}] });
    formTransport.setFieldsValue({
      transport_id: undefined,
      timeEnd: undefined,
    });
    setBoxes(formTransport.getFieldValue("boxes"));
  }, [item]);


  return (
    <div>
      <Form form={formTransport} onFinish={handelFinish}>
        <div
          style={{
            marginBottom: 10,
            flexDirection: "row",
            alignItems: "center",
            paddingRight: 10,
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 10,
          }}
        >
          <div>
            <Typography.Text strong style={{}}>
              ข้อมูลปริ้น Label
            </Typography.Text>
          </div>

          <Form.Item
            label="เลือกจังหวัด"
            className="form-transport"
            name="province_address_id"
            // required
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาเลือกจังหวัด",
            //   },
            // ]}
          >
            <Select
              placeholder="เลือกจังหวัด"
              filterOption={filterOption}
              showSearch
              onSelect={(value) => {
                setProvinceIdAddress(value);
                setDistrictIdAddress(0);
                // setProvinceIdstart(value);
                formTransport.setFieldsValue({
                  district_address_id: undefined,
                  parking_id: undefined,
                });
              }}
            >
              {childrenProviceStart}
            </Select>
          </Form.Item>
          <Form.Item
            label="เลือกอำเภอ"
            className="form-transport"
            name="district_address_id"
            // required
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาเลือกอำเภอ",
            //   },
            // ]}
          >
            <Select
              placeholder="เลือกอำเภอ"
              onSelect={(value) => {
                setDistrictIdAddress(value);
                formTransport.setFieldsValue({
                  parking_id: undefined,
                });
              }}
              showSearch
              filterOption={filterOption}
            >
              {masterDistrictDataAddress?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="จุดส่งสินค้า"
            name="parking_id"
            required
            rules={[
              {
                required: true,
                message: "กรุณาเลือกจุดส่งสินค้า",  
              },
            ]}
          >
            <Select
              showSearch
              placeholder="จุดส่งสินค้า"
              optionFilterProp="children"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <div style={{ marginTop: 10 }}>
                    <Button
                      style={{ width: "100%" }}
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowParking(true);
                      }}
                    >
                      เพิ่มจุดจอด
                    </Button>
                  </div>
                </>
              )}
              onSelect={(value) => {
                // find delivery point by value
                const selectDeliveryPoint = deliveryPointList.find((item) => {
                  return item.id.includes(value);
                });

                console.log("selectDeliveryPoint:", selectDeliveryPoint);

                setDeleveryPointId(value);

                if (selectDeliveryPoint?.district_id) {
                  formTransport.setFieldsValue({
                    district_address_id: selectDeliveryPoint.district_id,
                  });
                }

                setDeliveryPointSelect(selectDeliveryPoint);

                formTransport.setFieldsValue({
                  transport_id: undefined,
                  timeEnd: undefined,
                });
              }}
            >
              {childrenParking}
            </Select>
          </Form.Item>

          <Form.Item
            className="form-transport"
            name="transport_id"
            label="เลือกขนส่ง"
            required
            rules={[
              {
                required: true,
                message: "กรุณาเลือกการจัดส่ง",
              },
            ]}
          >
            <Select
              allowClear
              loading={isLoading}
              showSearch
              placeholder="กรุณาเลือกการจัดส่ง"
              optionFilterProp="children"
              value={selectTransport?.id}
              onSelect={(value) => {
                setSelectTransport(
                  masterTransport.find((item) => item.id === value)
                );
                setTransportIdSelect(value);
                // getParkingList(value);

                // let select = masterTransport.find((item) => item.id === value);

                formTransport.setFieldsValue({
                  timeEnd: undefined,
                });
              }}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  {/* <div style={{ marginTop: 10 }}>
                  <ModalTransport refetch={refetch} />
                </div> */}
                </>
              )}
            >
              {childrenTransport}
            </Select>
          </Form.Item>

          {/* select times  */}
          <Form.Item
            label="เวลาถึงโดยประมาณ"
            name="timeEnd"
            // required
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาเลือกเวลา",
            //   },
            // ]}
          >
            <Select
              placeholder="เลือกเวลา"
              showSearch
              optionFilterProp="children"
              allowClear
            >
              {times.map((item) => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.List name="boxes">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space key={key} style={{ display: "flex" }} align="baseline">
                    <Form.Item label="จำนวนที่ส่ง" required></Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "box_id"]}
                      rules={[
                        { required: true, message: "กรุณาเลือกขนาดกล่อง" },
                      ]}
                    >
                      <Select
                        placeholder="เลือกขนาดกล่อง"
                        style={{ width: 150 }}
                        size="middle"
                        onChange={() =>
                          setBoxes(formTransport.getFieldValue("boxes"))
                        }
                      >
                        {masterBoxSizeRemain.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "qty"]}
                      rules={[
                        //min: 1 and required
                        {
                          required: true,
                          message: "กรุณาใส่จำนวนกล่อง",
                        },
                        {
                          validator(rule, value, callback) {
                            if (value < 1) {
                              return Promise.reject("จำนวนกล่องต้องมากกว่า 0");
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="จำนวนกล่อง"
                        type="number"
                        size="small"
                        min={1}
                        onChange={() => {
                          setBoxes(formTransport.getFieldValue("boxes"));
                        }}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => {
                        remove(name);
                        setBoxes(formTransport.getFieldValue("boxes"));
                      }}
                    />
                  </Space>
                ))}
                <Form.Item>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      type="dashed"
                      onClick={() => {
                        add({ box_size_id: undefined, box_amount: undefined });
                        setBoxes(formTransport.getFieldValue("boxes"));
                      }}
                      block
                      icon={<PlusOutlined />}
                      style={{ maxWidth: 150 }}
                      disabled={
                        masterBoxSizeRemain.length === 0 ||
                        boxes.length === masterBoxSize?.data?.length
                      }
                    >
                      เพิ่มกล่อง
                    </Button>
                  </div>
                </Form.Item>
              </>
            )}
          </Form.List>
          {/* <Form.Item
            label="จำนวนลังที่สั่ง"
            name="order_box"
            rules={[
              {
                required: true,
                message: "กรุณาใส่จำนวนลังที่สั่ง",
              },
            ]}
          >
            <Input type="number" size="small" />
          </Form.Item> */}
          <Form.Item label="จำนวนลังรวมทั้งหมด" name="transport_box">
            <Typography.Text>
              {boxes.reduce((acc, item) => {
                return acc + (Number(item.qty) || 0);
              }, 0)}
            </Typography.Text>
          </Form.Item>
          <Form.Item
            label="หมายเหตุจัดส่ง"
            name="remark_box"
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาใส่หมายเหตุจัดส่ง",
            //   },
            // ]}
          >
            <Input.TextArea placeholder="หมายเหตุจัดส่ง" />
          </Form.Item>
        </div>
        {/* <Typography.Text strong style={{}}>
          ข้อมูลขนส่ง
        </Typography.Text> */}

        <Form.Item
          //label="ขนส่ง"
          name="transport_name"
          className="form-transport"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณากรอกขนส่ง",
          //   },
          // ]}
        >
          <Input hidden={true} />
        </Form.Item>
        {/* <Form.Item
          label="สถานีต้นทาง"
          name="station_start"
          className="form-transport"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณากรอกสถานีต้นทาง",
          //   },
          // ]}
        >
          <Input size="small" placeholder="กรุณากรอกสถานีต้นทาง" />
        </Form.Item> */}
        {/* <Form.Item
          label="จังหวัดต้นทาง"
          className="form-transport"
          name="province_start_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกจังหวัดต้นทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกจังหวัดต้นทาง"
            filterOption={filterOption}
            showSearch
            onSelect={(value) => {
              setProvinceIdstart(value);
              formTransport.setFieldsValue({
                district_start_id: undefined,
              });
            }}
          >
            {childrenProviceStart}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="อำเภอต้นทาง"
          className="form-transport"
          name="district_start_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกอำเภอต้นทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกอำเภอต้นทาง"
            onSelect={(value) => {}}
            showSearch
            filterOption={filterOption}
          >
            {masterDistrictDataStart?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="สถานีปลายทาง"
          name="station_end"
          className="form-transport"
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกสถานีปลายทาง",
          //   },
          // ]}
        >
          <Input size="small" placeholder="กรุณากรอกสถานีปลายทาง" />
        </Form.Item> */}
        {/* <Form.Item
          label="จังหวัดปลายทาง"
          className="form-transport"
          name="province_end_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกจังหวัดปลายทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกจังหวัดปลายทาง"
            showSearch
            filterOption={filterOption}
            onSelect={(value) => {
              setProvinceIdend(value);
              formTransport.setFieldsValue({
                district_end_id: undefined,
              });
            }}
          >
            {childrenProviceEnd}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="อำเภอปลายทาง"
          className="form-transport"
          name="district_end_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกอำเภอปลายทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกอำเภอปลายทาง"
            showSearch
            filterOption={filterOption}
          >
            {masterDistrictDataEnd?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item> */}
        {/* <Form.Item label="ออก" className="form-transport" name="timeStart">
          <TimePicker
            style={{ width: "100%" }}
            size="middle"
            format={"HH:mm"}
          />
        </Form.Item> */}
        {/* <Form.Item label="ถึง" className="form-transport" name="timeEnd">
          <TimePicker
            style={{ width: "100%" }}
            size="middle"
            format={"HH:mm"}
          />
        </Form.Item> */}
        {/* <Form.Item label="ประเภทขนส่ง" className="form-transport" name="type">
          <Select
            placeholder="เลือกประเภทขนส่ง"
            showSearch
            filterOption={filterOption}
          >
            {childrenTransportType}
          </Select>
        </Form.Item>
        <Form.Item
          label="เลขทะเบียนรถ"
          name="license_plate"
          className="form-transport"
        >
          <Input size="small" placeholder="กรุณากรอกเลขทะเบียนรถ" />
        </Form.Item>
        <Form.Item label="หมายเลขรถ" name="car_no" className="form-transport">
          <Input size="small" placeholder="กรุณากรอกหมายเลขรถ" />
        </Form.Item>
        {/* <Form.Item label="จุดจอดที่ลูกค้าต้องการ" name="remark">
          <Input.TextArea placeholder="จุดจอดที่ลูกค้าต้องการ"/>
        </Form.Item> */}
      </Form>

      <Modal
        title="เพิ่มจุดส่งสินค้า"
        open={showParking}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        // onOk={() => form.submit()}
        style={{ top: 20 }}
        footer={[
          <Button key="back" onClick={() => onCloseModal()}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => formModal.submit()}
          >
            บันทึก
          </Button>,
        ]}
      >
        <WrapperAll>
          <Form form={formModal} onFinish={onFinishModal}>
            <DescriptionForm form={formModal} />
          </Form>
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default TransportSeleect;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
